/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Tlm_3Inputs */

const en_svc_backend_development_tlm_3 = /** @type {(inputs: Svc_Backend_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`auth`)
};

const ar_svc_backend_development_tlm_3 = /** @type {(inputs: Svc_Backend_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المصادقة`)
};

const bn_svc_backend_development_tlm_3 = /** @type {(inputs: Svc_Backend_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`auth`)
};

const de_svc_backend_development_tlm_3 = /** @type {(inputs: Svc_Backend_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth`)
};

const es_svc_backend_development_tlm_3 = /** @type {(inputs: Svc_Backend_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`autenticación`)
};

const fr_svc_backend_development_tlm_3 = /** @type {(inputs: Svc_Backend_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`authentification`)
};

const pt_svc_backend_development_tlm_3 = /** @type {(inputs: Svc_Backend_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`autenticação`)
};

const zh_svc_backend_development_tlm_3 = /** @type {(inputs: Svc_Backend_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`授权`)
};

const tr_svc_backend_development_tlm_3 = /** @type {(inputs: Svc_Backend_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yetki`)
};

const ru_svc_backend_development_tlm_3 = /** @type {(inputs: Svc_Backend_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`авторизация`)
};

const pl_svc_backend_development_tlm_3 = /** @type {(inputs: Svc_Backend_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`autoryzacja`)
};

/**
* | output |
* | --- |
* | "auth" |
*
* @param {Svc_Backend_Development_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_tlm_3 = /** @type {((inputs?: Svc_Backend_Development_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_tlm_3(inputs)
	if (locale === "bn") return bn_svc_backend_development_tlm_3(inputs)
	if (locale === "de") return de_svc_backend_development_tlm_3(inputs)
	if (locale === "es") return es_svc_backend_development_tlm_3(inputs)
	if (locale === "fr") return fr_svc_backend_development_tlm_3(inputs)
	if (locale === "pt") return pt_svc_backend_development_tlm_3(inputs)
	if (locale === "zh") return zh_svc_backend_development_tlm_3(inputs)
	if (locale === "tr") return tr_svc_backend_development_tlm_3(inputs)
	if (locale === "ru") return ru_svc_backend_development_tlm_3(inputs)
	if (locale === "pl") return pl_svc_backend_development_tlm_3(inputs)
	return en_svc_backend_development_tlm_3(inputs)
});
export { svc_backend_development_tlm_3 as "svc_backend-development_tlm_3" }